module.exports = __webpack_public_path__ + "static/media/about-us.f9854cf8.webp";